<template>
  <div class="footer-bar-comp comp" v-show="!invisible">
    <router-link class="router-item" to="/discover">
      <div class="wrap">
        <img
          class="footer-img"
          v-if="currentPath === '/discover'"
          src="../assets/images/discover_on.png"
        />
        <img
          class="footer-img"
          v-else
          src="../assets/images/discover_off.png"
        />
        <span
          class="text--sub"
          :class="{ 'is-active': currentPath === '/discover' }"
          >发现</span
        >
      </div>
    </router-link>
    <router-link class="router-item" to="/data">
      <div class="wrap" @click="toDataPage">
        <img
          class="footer-img"
          v-if="currentPath === '/data'"
          src="../assets/images/digital_on.png"
        />
        <img
          class="footer-img"
          v-else
          src="../assets/images/digital_off.png"
        />
        <span
          class="text--sub"
          :class="{ 'is-active': currentPath === '/data'}"
          >数据</span
        >
      </div>
    </router-link>
    <router-link class="router-item" to="/digital">
      <div class="wrap">
        <img
          class="footer-img"
          v-if="currentPath === '/digital'"
          src="../assets/images/data_on.png"
        />
        <img class="footer-img" v-else src="../assets/images/data_off.png" />
        <span
          class="text--sub"
          :class="{ 'is-active': currentPath === '/digital' }"
          >智库</span
        >
      </div>
    </router-link>
    <!-- <router-link class="router-item" to="/vip">
      <div class="wrap">
        <img
          class="footer-img"
          v-if="currentPath === '/vip'"
          src="../assets/images/vip_on.png"
        />
        <img class="footer-img" v-else src="../assets/images/vip_off.png" />
        <span class="text--sub" :class="{ 'is-active': currentPath === '/vip' }"
          >VIP</span
        >
      </div>
    </router-link> -->
    <router-link class="router-item" to="/college">
      <div class="wrap">
        <img
          class="footer-img"
          v-if="currentPath === '/college'"
          src="../assets/images/college_on.png"
        />
        <img class="footer-img" v-else src="../assets/images/college_off.png" />
        <span
          class="text--sub"
          :class="{ 'is-active': currentPath === '/college' }"
          >学院</span
        >
      </div>
    </router-link>
    <router-link class="router-item" to="/my">
      <div class="wrap">
        <img
          class="footer-img"
          v-if="currentPath === '/my'"
          src="../assets/images/my_on.png"
        />
        <img class="footer-img" v-else src="../assets/images/my_off.png" />
        <span class="text--sub" :class="{ 'is-active': currentPath === '/my' }"
          >我的</span
        >
      </div>
    </router-link>
  </div>
</template>
<script>

import envnetBus from '@/utils/eBus'
export default {
  name: 'footerBar',
  data() {
    return {
      currentPath: ''
    };
  },
  computed: {
    invisible() {
      return (
        ['/discover', '/data', '/digital', '/vip', '/college', '/my'].indexOf(
          this.currentPath
        ) === -1
      );
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.currentPath = to.path;
      }
    }
  },
  methods: {
    toDataPage() {
      envnetBus.$emit('showData', 0)
    }
  }
};
</script>
<style lang="stylus" scoped>
.footer-bar-comp {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-top: 1PX solid #eee;
    .router-item{
        flex: 1;
        .wrap{
            display: flex;
            flex-direction: column;
            align-items center;
            .footer-img{
              width: 58px;
              height: 58px;
              margin-bottom: 4px;
            }

            .text--sub {
              font-size: 20px;
              &.is-active{
                color: #8FC31E
              }
            }
        }
    }
}
</style>
